import { render, staticRenderFns } from "./SquareBox.vue?vue&type=template&id=b69856d8"
import script from "./SquareBox.vue?vue&type=script&lang=js"
export * from "./SquareBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports